/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PaymentRecordOperationType;

(function (PaymentRecordOperationType) {
  PaymentRecordOperationType["POLICY_PREMIUM"] = "policy_premium";
  PaymentRecordOperationType["AGENT_BILL_PAYMENT"] = "agent_bill_payment";
  PaymentRecordOperationType["PREMIUM_CHANGE"] = "premium_change";
  PaymentRecordOperationType["POLICY_MODIFY"] = "policy_modify";
  PaymentRecordOperationType["POLICY_CANCEL"] = "policy_cancel";
  PaymentRecordOperationType["POLICY_DISPUTE"] = "policy_dispute";
  PaymentRecordOperationType["POLICY_REINSTATEMENT"] = "policy_reinstatement";
})(PaymentRecordOperationType || (PaymentRecordOperationType = {}));